import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./LPG.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function LPG() {

    useEffect(() => {
    
      trackPageVisit("LPG");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);

     

  const DEFAULT_VALVES = {
  FCV_3801: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3802: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3803: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3804: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("LPG_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3801: { ...DEFAULT_VALVES.FCV_3801, ...parsed.FCV_3801 },
      FCV_3802: { ...DEFAULT_VALVES.FCV_3802, ...parsed.FCV_3802 },
      FCV_3803: { ...DEFAULT_VALVES.FCV_3803, ...parsed.FCV_3803 },
      FCV_3804: { ...DEFAULT_VALVES.FCV_3804, ...parsed.FCV_3804 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("LPG_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters,  } = usePlantStore();
                const TT_28023 = transmitters.TT_28023 || 0;
                const PT_28023 = transmitters.PT_28023 || 0;
                const FIC_28023 = transmitters.FIC_28023 || 0;
                const FIC_29011 = transmitters.FIC_29011 || 0;
                const PT_29011 = transmitters.PT_29011 || 0;
                const TT_29011 = transmitters.TT_29011 || 0;
  




  const xv3801Open = !valves?.XV_3801;
  const xv3802Open = !valves?.XV_3802;
  const xv3803Open = !valves?.XV_3803;
  const xv3804Open = !valves?.XV_3804;
  const xv3805Open = !valves?.XV_3805;
  const xv3806Open = !valves?.XV_3806;


    const FIC_3801 = FIC_29011;
    const PT_3801 = PT_29011;
    const TT_3801 = TT_29011;


    
/* =========================================================
              SPLITTING MAIN LPG LINE
========================================================= */

const openLPGTankSplit =
[
  xv3801Open,
  xv3802Open
].filter(Boolean).length;

const FIC_3802 =
  xv3801Open
    ? FIC_3801 / openLPGTankSplit
    : 0;

const FIC_3803 =
  xv3802Open
    ? FIC_3801 / openLPGTankSplit
    : 0;






/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   P-3801A / P-3801B STATUS
========================================================= */

const P3801A_Running =
pumpData?.["P-3801A"]?.running ?? false;

const P3801B_Running =
pumpData?.["P-3801B"]?.running ?? false;

const P3801_Running =
P3801A_Running || P3801B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P3801_CAPACITY = 12.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV3801_Opening =
(valveData?.FCV_3801?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC3804 =
(
P3801_Running
)
?
P3801_CAPACITY *
FCV3801_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_3804 || 0);

const next =
current +
(targetFIC3804-current)*0.12;

return{

...prev,

FIC_3804:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC3804
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_3804 || 0.03);

const currentTemp =
Number(prev.TT_3804 || 28);

const currentFlow =
Number(prev.FIC_3804 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P3801_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV3801_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV3801_Opening<0.20){

const restriction =
(0.20-FCV3801_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV3801_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV3801_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV3801_Opening<0.20){

const restriction=
(0.20-FCV3801_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_3804:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_3804:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P3801_Running,
FCV3801_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_3804 =
Number(
processData.FIC_3804 || 0
);

const PT_3804 =
Number(
processData.PT_3804 || 0.03
);

const TT_3804 =
Number(
processData.TT_3804 || 28
);





/* =========================================================
   V-3801 SUCTION FLOW
========================================================= */
const FIC_3805 = (P3801A_Running && xv3803Open) ? FIC_3804 : 0.003;

/* =========================================================
   V-3802 SUCTION FLOW
========================================================= */
const FIC_3806 = (P3801A_Running && xv3804Open) ? FIC_3804 : 0.003;



useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_3804 === FIC_3804 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3804,
    }
  });

}, [FIC_3804, ]);




   

  return (
    <div className="LPG-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 378px",
          zIndex: 10,
        }}
      >
        LPG TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3801 */}
      <Valve
        className="XV-3801"
        tag="XV_3801"
        x={351}
        y={115}
        isClosed={valves.XV_3801}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-3802 */}
      <Valve
        className="XV-3802"
        tag="XV_3802"
        x={830}
        y={115}
        isClosed={valves.XV_3802}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3803 */}
      <Valve
        className="XV-3803"
        tag="XV_3803"
        x={434}
        y={365}
        isClosed={valves.XV_3803}
        toggle={toggleValve}
      />

      {/* XV-3804 */}
      <Valve
        className="XV-3804"
        tag="XV_3804"
        x={988}
        y={385}
        isClosed={valves.XV_3804}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3805 */}
      <Valve
        className="XV-3805"
        tag="XV_3805"
        x={1033}
        y={561}
        isClosed={valves.XV_3805}
        toggle={toggleValve}
      />




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3801 */}
        <div
            style={{ position: "absolute", left: 865, top: 553}}
            onMouseEnter={() => setHoveredValve("FCV_3801")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3801")}
          >

            {hoveredValve === "FCV_3801" && (
              <div style={tagStyle}>
                FCV_3801
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3801">
                    
          <defs>
            <linearGradient id="metal_3801">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3801)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3801)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
     
      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 380 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 380 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3801?.opening || 0)}
        x={887}
        y={600}
      />




    <Transmitter
        tag="FIC_3801"
        value={[FIC_3801]}
        x={121}
        y={75}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LPG FROM STABILIZER TOWER THROUGH E-304A/B TO LPG STORAGE TANKS"
      />

    <Transmitter
        tag="PT_3801"
        value={[PT_3801]}
        x={211}
        y={75}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF LPG FROM STABILIZER TOWER THROUGH E-304A/B TO LPG STORAGE TANKS"
      />

      <Transmitter
        tag="FIC_3802"
        value={[FIC_3802]}
        x={411}
        y={123}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LPG FROM STABILIZER TOWER THROUGH E-304A/B TO LPG STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3803"
        value={[FIC_3803]}
        x={741}
        y={123}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LPG FROM E-117A/B TO LPG STORAGE TANKS (V-303 AND V-304)"
      />

      <Transmitter
        tag="FIC_3804"
        value={[FIC_3804]}
        x={783}
        y={593}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LPG FROM P-3801A/B TO LOADING OR BLENDING"
      />


      <Transmitter
        tag="PT_3804"
        value={[PT_3804]}
        x={683}
        y={593}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF LPG FROM P-3801A/B TO LOADING OR BLENDING"
      />
    
    <Transmitter
        tag="TT_3804"
        value={[TT_3804]}
        x={683}
        y={503}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF LPG FROM P-3801A/B TO LOADING OR BLENDING"
      />

    <Transmitter
        tag="TT_3801"
        value={[TT_3801]}
        x={311}
        y={75}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF LPG FROM STABILIZER TOWER THROUGH E-304A/B TO LPG STORAGE TANKS"
      />

      <Transmitter
        tag="FIC_3804"
        value={[FIC_3804]}
        x={1113}
        y={553}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LPG FROM P-3801A/B TO LOADING GANTRY"
      />





    <LevelTransmitterIndicator
      tag="LT_3801"
      totalLevel={20000}
      inflows={[FIC_3802]}
      outflows={[FIC_3805]}
      responseFactor={0.05}
      columnX={250}
      columnY={175}
      columnWidth={399}
      columnHeight={158}
      textX={130}
      textY={190}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="LPG"
    />


      <LevelTransmitterIndicator
      tag="LT_3802"
      totalLevel={20000}
      inflows={[FIC_3803]}
      outflows={[FIC_3806]}
      responseFactor={0.05}
      columnX={764}
      columnY={174}
      columnWidth={399}
      columnHeight={158}
      textX={1200}
      textY={190}
      showFlow={true}
        backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="LPG"
    />

   


            <Pump
              tag="P-3801A"
              x={568}
              y={520}
              rpm={1800}
              bladeCount={pumpData?.["P-3801A"]?.bladeCount || 3}
              size={pumpData?.["P-3801A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-3801B"
              x={568}
              y={614}
              rpm={1800}
              bladeCount={pumpData?.["P-3801B"]?.bladeCount || 3}
              size={pumpData?.["P-3801B"]?.size || 45}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default LPG;